import log from 'loglevel';
import { useTranslation } from 'react-i18next';
import { History } from '@mui/icons-material';
import { PencilAlt } from '../../../icons/pencil-alt';
import TableAction from '../../../components/MenuMoreVert';
import { TABLE } from '../../../consts';
import { User } from '../../../icons/user';
import { STRING_KEYS } from '../../../language/keys';
import { useAuth } from '../../../hooks/useAuth';
import { PERMISSIONS } from '../../../consts/permissions';

const TAG = '[POSITION_DETAILS_ACTION_COMPONENT]';
const { ACTIONS } = TABLE;

type PositionDetailsActionProps = {
  id: string,
  moveToViewMatch: (id:string) => void,
  moveToEditMatch: (id:string) => void,
  moveToEditMatchAndOpenModal: (id:string) => void,
}

const PositionDetailsAction = ({
  id,
  moveToViewMatch,
  moveToEditMatch,
  moveToEditMatchAndOpenModal,
}:PositionDetailsActionProps): JSX.Element | null => {
  const { t: translate } = useTranslation();
  const { hasPermissions } = useAuth();

  const prepareMatchViewOption = () => {
    if (hasPermissions([PERMISSIONS.MATCH_EDIT])) {
      return {
        type: ACTIONS.MATCH_EDIT,
        key: STRING_KEYS.POSITIONS_DETAILS_TABLE_EDIT_MATCH_ACTION,
        title: translate(STRING_KEYS.EDIT),
        icon: <PencilAlt />,
      };
    }

    return {
      type: ACTIONS.VIEW,
      key: STRING_KEYS.POSITIONS_DETAILS_TABLE_VIEW_MATCH_ACTION,
      title: translate(STRING_KEYS.VIEW),
      icon: <PencilAlt />,
      permissions: [PERMISSIONS.MATCH_VIEW],
    };
  };

  const defaultActions = [
    {
      ...prepareMatchViewOption(),
    },
    {
      type: ACTIONS.VIEW_HISTORY_LOG,
      key: STRING_KEYS.POSITIONS_DETAILS_TABLE_VIEW_ACTIVITY_ACTION,
      icon: <History />,
      isDisabled: false,
      permissions: [PERMISSIONS.MATCH_HISTORY_LOG_VIEW],
    },
    {
      type: ACTIONS.EDIT,
      key: STRING_KEYS.POSITIONS_DETAILS_TABLE_EDIT_TALENT_ACTION,
      icon: <User />,
      isDisabled: true,
      permissions: [PERMISSIONS.TALENT_EDIT],
    },
  ];

  const actions = defaultActions.filter((action) => {
    return !action.permissions || hasPermissions(action.permissions);
  }).map((defaultAction) => ({
    ...defaultAction,
    title: translate(defaultAction.key),
    key: id,
  }));

  const handleActions = (key: string, type: string) => {
    switch (type) {
      case ACTIONS.VIEW: {
        moveToViewMatch(key);
        break;
      }
      case ACTIONS.MATCH_EDIT: {
        moveToEditMatch(key);
        break;
      }
      case ACTIONS.VIEW_HISTORY_LOG: {
        moveToEditMatchAndOpenModal(key);
        break;
      }
      default:
        log.warn(TAG, `Cannot find any handler for type:${type}`);
    }
  };

  if (!actions || actions.length <= 0) {
    return null;
  }

  return (
    <TableAction actions={ actions } handleActions={ handleActions } />
  );
};

export default PositionDetailsAction;
